import React from "react";
import PortfolioNavbar from "./elements/portfolionavbar";
import PortfolioBanner from "./elements/portfoliobanner";
import PortfolioFooter from "./elements/portfoliofooter";
import FaqQuestion from "./elements/faqquestion";
export default function Faq() {
  return (
    <div className="portfolio">
      <div className="portfoliopadding">
        <div className="portfoliohome">
          <PortfolioNavbar colortheme="blue" />
        </div>
        <div className="portfoliofaq">
          <div className="portfoliohomebodycontact">
            <button className="portfoliogradientbutton">FAQ</button>

            <h2 className="h2headerportfolio">FAQs</h2>
            <p>
              NeuroGen empowers medical professionals with innovative tools to
              practice, refine, and excel in their skills. <br />
              From differential diagnosis to case simulations and research
              verification,
            </p>
          </div>
          <div className="portfoliofaqbody">
            <FaqQuestion
              question="What are the different plans as well as the best discounts available?"
              answer="We offer four plans to support your exam preparation: Free, Basic, Essential, Visionary."
            />
            <FaqQuestion
              question="I'm having trouble with my payment, what should I do?"
              answer="It's essential to have a stable internet connection and to ensure all payment details are accurate for a
successful transaction. If you're still facing issues, please contact our support team."
            />
            <FaqQuestion
              question="Is NeuroGen available on mobile devices?"
              answer="Yes, NeuroGen is available through the web browser on your mobile device. We are also working on a mobile app for a better user experience."
            />{" "}
            <FaqQuestion
              question="How to change my email ID associated with Neurogen?"
              answer="We do not have the option to change the email ID for security reasons. Your email ID is considered the only identification that saves your progress and data."
            />{" "}
            <FaqQuestion
              question="I want to change my phone number associated with Neurogen."
              answer="To update your phone number, please checkout the profile page and update your phone number."
            />{" "}
            <FaqQuestion
              question="Do you offer a free plan?"
              answer="Yes, we offer a free plan. You can access the free plan by signing up on our website. The free plan includes a limited number of questions."
            />{" "}
            <FaqQuestion
              question="Who is Neurogen catered towards and for what?"
              answer="Neurogen is catered towards medical professionals, students, and researchers. We offer a wide range of tools to support your exam preparation, research, and clinical practice."
            />{" "}
            <FaqQuestion
              question="What are the payment options available?"
              answer="We accept all major credit and debit cards. We also accept payments through UPI and other online payment methods."
            />
          </div>
        </div>
        <PortfolioBanner />
        <PortfolioFooter />
      </div>
    </div>
  );
}
